<div
  class="card-form-group-container"
  [formGroup]="form">
  <mat-form-field>
    <textarea
      matInput
      placeholder="Indicazioni sull'oggetto (DESO)"
      formControlName="DESO">
    </textarea>
  </mat-form-field>
</div>
